import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { User, Lock, Bell, HelpCircle, LogOut, ChevronDown } from 'lucide-react';
import { useAuth } from '../../lib/auth/AuthContext';
import { useTheme } from '../../hooks/useTheme';
import { toast } from 'react-hot-toast';

export function UserProfileMenu() {
  const navigate = useNavigate();
  const { user, signOut } = useAuth();
  const { theme, setTheme } = useTheme();
  const [isOpen, setIsOpen] = useState(false);

  const menuItems = [
    {
      label: 'Profile Settings',
      icon: User,
      path: '/profile',
    },
    {
      label: 'Account Security',
      icon: Lock,
      path: '/profile/security',
    },
    {
      label: 'Notifications',
      icon: Bell,
      path: '/profile/notifications',
    },
    {
      label: 'Help & Support',
      icon: HelpCircle,
      path: '/profile/help',
    },
  ];

  const handleSignOut = async () => {
    try {
      await signOut();
      toast.success('Signed out successfully');
      navigate('/');
    } catch (error) {
      toast.error('Failed to sign out');
    }
  };

  const handleNavigation = (path: string) => {
    navigate(path);
    setIsOpen(false);
  };

  return (
    <div className="relative mt-auto border-t border-gray-200 p-4">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex w-full items-center justify-between rounded-lg px-2 py-2 hover:bg-gray-100"
      >
        <div className="flex items-center">
          <div className="h-8 w-8 rounded-full bg-purple-100 p-2">
            <User className="h-full w-full text-purple-600" />
          </div>
          <div className="ml-3 text-left">
            <p className="text-sm font-medium text-gray-700">
              {user?.user_metadata?.full_name || 'User'}
            </p>
            <p className="text-xs text-gray-500">{user?.email}</p>
          </div>
        </div>
        <ChevronDown className={`h-5 w-5 transform text-gray-500 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
      </button>

      {isOpen && (
        <div className="absolute bottom-full left-0 mb-2 w-full rounded-lg border border-gray-200 bg-white py-1 shadow-lg">
          {menuItems.map((item) => {
            const Icon = item.icon;
            return (
              <button
                key={item.label}
                onClick={() => handleNavigation(item.path)}
                className="flex w-full items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
              >
                <Icon className="mr-3 h-4 w-4" />
                {item.label}
              </button>
            );
          })}

          <div className="my-1 border-t border-gray-200" />
          
          <button
            onClick={handleSignOut}
            className="flex w-full items-center px-4 py-2 text-sm text-red-600 hover:bg-red-50"
          >
            <LogOut className="mr-3 h-4 w-4" />
            Sign Out
          </button>
        </div>
      )}
    </div>
  );
}